import Vue from 'vue'
import App from './App.vue'
import StockDailyChart from './components/StockDailyChart.vue'
import ThsTradePanel from './components/ThsTradePanel.vue'
import EtfMomentumPanel from './components/EtfMomentumPanel.vue'
import MarketRepairPanel from './components/MarketRepairPanel.vue'

Vue.config.productionTip = false
Vue.component('stock-daily-chart', StockDailyChart)
Vue.component('ths-trade-panel', ThsTradePanel)
Vue.component('etf-momentum-panel', EtfMomentumPanel)
Vue.component('market-repair-panel', MarketRepairPanel)

new Vue({
  render: h => h(App),
}).$mount('#app')
